import React from "react";
import Body from "./Body";

const Fees = () => {
  const _this = {};
  return <Body {..._this} />;
};

export default Fees;
